import { render, staticRenderFns } from "./RolePage.vue?vue&type=template&id=5e202fd0"
import script from "./RolePage.vue?vue&type=script&lang=js"
export * from "./RolePage.vue?vue&type=script&lang=js"
import style0 from "./RolePage.vue?vue&type=style&index=0&id=5e202fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports